import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'

import { useWizzardHeader } from '../../context/WizzardHeaderContext'

export interface WizzardHeaderContentWrapperProps extends GridProps {}

export const WizzardHeaderContentWrapper = ({
  children,
  sx,
  ...rest
}: WizzardHeaderContentWrapperProps) => {
  const { isScrolled } = useWizzardHeader()

  return (
    <Grid
      sx={{
        px: { md: 4 },
        gap: { base: 4, md: isScrolled ? 4 : 6 },
        alignContent: 'start',
        alignItems: 'start',
        transition: 'all 200ms ease-in-out',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Grid>
  )
}
